'use client'

import { setElementVars } from '@vanilla-extract/dynamic'
import { useEffect } from 'react'
import { tokens } from 'ui/src/theme/tokens.css'
import { textDecorationColor } from '@/components/TextLink/TextLink.css'

export function RandomHoverColor() {
  useEffect(() => {
    setElementVars(document.body, { [textDecorationColor]: getRandomColor() })
  }, [])
  return null
}

const hoverColors = [
  tokens.legacyColors.blue600,
  tokens.legacyColors.green600,
  tokens.legacyColors.amber600,
  tokens.legacyColors.red600,
  tokens.legacyColors.pink600,
  tokens.legacyColors.purple600,
  tokens.legacyColors.teal600,
]

const getRandomColor = () => hoverColors[Math.floor(Math.random() * hoverColors.length)]
